import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { USDT_CONTRACT_ADDRESS } from "../../utils/Enviroment";
import { BigNumber } from "bignumber.js";

export const useTransfer = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const contract = getBalance(USDT_CONTRACT_ADDRESS, web3);

  function toWei(etherAmount) {
    // Convert to fixed decimal string first
    const fixedValue = parseFloat(etherAmount).toFixed(18);
    const [integerPart = "0", decimalPart = ""] = fixedValue.split(".");

    // Pad decimal to exactly 18 places
    const paddedDecimal = decimalPart.padEnd(18, "0").substring(0, 18);

    // Combine and convert to BigInt to avoid precision issues
    const wei = BigNumber(integerPart + paddedDecimal);

    return wei.toString();
  }
  const transferFunds = useCallback(
    async (toAddress, amount, isToken) => {
      console.log(toAddress, amount, isToken, "toAddress, amount, isToken");

      try {
        if (isToken) {
          // Token transfer (existing working code)
          let gasPrice = await web3.eth.getGasPrice();
          const usdtAmount = web3.utils.toWei(amount.toString(), "mwei");
          console.log(usdtAmount, "usdtAmount");

          return await contract.methods
            .transfer(toAddress, usdtAmount)
            .send({ from: account, gasPrice: gasPrice });
        } else {
          const result = toWei(amount);
          // ETH transfer with proper gas estimation
          // const ethAmount = web3.utils.toWei(amount.toString(), "ether");

          // Get current gas price
          const gasPrice = await web3.eth.getGasPrice();

          // Create transaction object for gas estimation
          const transactionObject = {
            from: account,
            to: toAddress,
            value: result,
            gasPrice: gasPrice,
          };

          // Estimate gas limit
          const gasLimit = await web3.eth.estimateGas(transactionObject);

          // Add some buffer to gas limit (10% extra)
          const gasLimitWithBuffer = Math.floor(gasLimit * 1.1);

          // Send transaction with all required parameters
          return await web3.eth.sendTransaction({
            from: account,
            to: toAddress,
            value: result, // Keep as Wei string, don't convert to hex
            gas: gasLimitWithBuffer, // Use 'gas' instead of 'gasLimit'
            gasPrice: gasPrice,
          });
        }
      } catch (error) {
        console.error("Transfer error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  return transferFunds;
};
